import React from 'react';
import { TrackingStat } from '../liveTrackingTypes';
import styles from './TrackingStatCard.module.css';

interface TrackingStatCardProps {
  stat: TrackingStat;
  icon: React.ReactNode;
}

export const TrackingStatCard: React.FC<TrackingStatCardProps> = ({ stat, icon }) => (
  <div className={styles.card}>
    <div className={styles.iconWrapper} style={{ background: stat.iconBg }}>
      <span style={{ color: stat.iconColor }}>{icon}</span>
    </div>
    <p className={styles.label}>{stat.label}</p>
    <p className={styles.value} style={{ color: stat.valueColor }}>{stat.value}</p>
  </div>
);
